(function(){
  function initScope(root){
    root.querySelectorAll('[data-aura-gallery]').forEach(function(gallery){
      var main=gallery.querySelector('[data-aura-main-image]');
      gallery.querySelectorAll('[data-aura-thumb]').forEach(function(btn){
        btn.addEventListener('click',function(){
          if(!main)return;
          main.src=btn.dataset.src;
          main.srcset='';
          gallery.querySelectorAll('[data-aura-thumb]').forEach(function(x){x.classList.remove('is-active')});
          btn.classList.add('is-active');
        });
      });
    });
    root.querySelectorAll('[data-aura-accordion]').forEach(function(acc){
      var btn=acc.querySelector('[data-aura-accordion-button]');
      if(!btn)return;
      btn.addEventListener('click',function(){
        var open=acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded',open?'true':'false');
      });
    });
    root.querySelectorAll('[data-aura-product-form]').forEach(function(form){
      var select=form.querySelector('[data-aura-variant-select]');
      var price=form.closest('[data-aura-product-area]')?.querySelector('[data-aura-price]');
      var compare=form.closest('[data-aura-product-area]')?.querySelector('[data-aura-compare]');
      var button=form.querySelector('[data-aura-submit]');
      function sync(){
        if(!select)return;
        var opt=select.options[select.selectedIndex];
        if(price)price.textContent=opt.dataset.price||'';
        if(compare){
          compare.textContent=opt.dataset.compare||'';
          compare.style.display=opt.dataset.compare?'inline':'none';
        }
        if(button){
          var available=opt.dataset.available==='true';
          button.disabled=!available;
          button.textContent=available?(button.dataset.availableText||'Add to cart'):(button.dataset.soldText||'Sold out');
        }
      }
      if(select){select.addEventListener('change',sync);sync();}
    });
    root.querySelectorAll('[data-aura-scroll-buy]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var target=document.querySelector('[data-aura-product-form]');
        if(target)target.scrollIntoView({behavior:'smooth',block:'center'});
      });
    });
  }
  function init(){initScope(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(e){initScope(e.target)});
})();